import {EmbeddingType} from 'common/src/modules/ragSearch/ragSearch.enums';
import {ToolName} from '../copilot.enums';
import {generalKnowledgeToolSchema} from '../copilot.schemas';
import {ToolExecuteParams, ToolResult} from '../copilot.types';
import tool from '../utils/creators/tool';
import invokeRagArticleSearch from '../utils/invokeRagArticleSearch';

export function generalKnowledgeTool() {
  async function execute({
    input: {prompt},
    toolUtils,
    callChain,
  }: ToolExecuteParams<typeof generalKnowledgeToolSchema>): Promise<ToolResult> {
    const result = await invokeRagArticleSearch({
      prompt,
      embeddingTypes: [
        EmbeddingType.ProductDocumentation,
        EmbeddingType.Agency,
        EmbeddingType.PublicApi,
      ],
      toolUtils,
      callChain,
    });

    return result;
  }

  return tool({
    name: ToolName.GeneralKnowledge,
    displayName: 'Searching knowledge',
    description: 'Search for answers in the Knowledge Center',
    execute,
    inputSchema: generalKnowledgeToolSchema,
  });
}
